import React, { useEffect, useState } from 'react';
import ConfirmationCheckoutPage from "./confirmation-checkout-page";
import CongratsPage from "./congrats-page";
import ConnectWalletPrivatePage from "./connect-wallet-private-page";
import QueuePage from "./queue-page";
import QuizPage from "./quiz-page";
import ShippingInformationPage from "./shipping-information-page";
import SaleStartingPage from "./sales-starting-page";
import SaleFinishedPage from "./sales-finished-page";
import { UpdateStatePageNumber } from '../services/last-state-service';
import { useDispatch, useSelector } from 'react-redux';
import { OpenTxid, SavedStateKey, SessionId, UserDeadline } from '../constants/localStorageKeys';
import { resetOrderInfo, setOrderInfo } from '../redux/orderInfoSlice';
import { setOrderItem } from '../redux/orderItemAmountSlice';
import { setWalletAsync } from '../redux/walletSlice';
import { selectConfig, setConfigAsync } from '../redux/configSlice';
import { setPrivateSale, setPublicSale } from '../redux/saleTypeSlice';
import { setStockItemsStats } from '../redux/stockItemsStatsSlice';
import { showToastError } from '../components/toastNotification';
import { resetSession, setSession } from '../redux/sessionSlice';
import LoaderPage from './loading-page';
import SaleSoonPage from './sale-soon-page';
import createBackendAxios from '../services/backend-api-service';
import { ApiUrl } from '../constants/api';
import { io } from 'socket.io-client';

export let BackendApi;

export let Socket;

const pages = [
  {
    order: 1,
    stepComponent: (props) => <ConnectWalletPrivatePage {...props}/>,
  },

  {
    order: 2,
    stepComponent: (props) => <QuizPage {...props}/>,
  },

  {
    order: 3,
    stepComponent: (props) => <ShippingInformationPage {...props}/>,
  },

  {
    order: 4,
    stepComponent: (props) => <ConfirmationCheckoutPage {...props}/>,
  },

  {
    order: 5,
    stepComponent: (props) => <CongratsPage {...props}/>,
  },

  {
    order: 100,
    stepComponent: (props) => <QueuePage {...props}/>,
  },

  {
    order: 101,
    stepComponent: (props) => <LoaderPage {...props}/>,
  },
  
  {
    order: 500,
    stepComponent: (props) => <SaleSoonPage {...props}/>,
  },
  {
    order: 501,
    stepComponent: (props) => <SaleStartingPage {...props}/>,
  },
  {
    order: 502,
    stepComponent: (props) => <SaleFinishedPage {...props}/>,
  },
]

const RouterPage = () => {
  const startStep = 1;
  const [currentStep, setCurrentStep] = useState(101);
  const [contractIntervalId, setContractIntervalId] = useState(0);
  const config = useSelector(selectConfig);
  const dispatch = useDispatch();

  const startRetryingCreateContract = async ({address, orderItemAmount}) => {
    const intervalId = setInterval(() => {
      RetryCreateContract({address: address, orderItemAmount: orderItemAmount});
    }, 15000);

    setContractIntervalId(intervalId);
  }

  const RetryCreateContract = async ({address, orderItemAmount}) => {
    const response = await BackendApi.post(
      `/script/open`,
      {
        walletAddress: address,
        amount: orderItemAmount 
      }
    );

    if (response.status === 500) {
      clearInterval(contractIntervalId);
    }
  }

  const fetchStockStats = async () => {
    try {
      const result = await BackendApi.get(`/script/stats`);
      processNewStats(result.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  function processNewStats(stats) {
    dispatch(setStockItemsStats(stats));
    const storedData = localStorage.getItem(SavedStateKey);
    const combinedData = storedData ? JSON.parse(storedData) : {};
    const actualPageNumber = combinedData.pageNumber ? combinedData.pageNumber : startStep;

    if ((actualPageNumber === 2 || actualPageNumber === 100) && stats && stats.inventory === 0 && stats.pending === 0) {
      handleGoHomepage();
      showToastError({title: 'Order error', body: 'Sorry, stock just become empty'});
    }
  }

  const fetchSaleType = async () => {
    try {
      const result = await BackendApi.get(`/script/is-private-sale`);
      if (result.data)
        dispatch(setPrivateSale());
      else
        dispatch(setPublicSale());
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    BackendApi = createBackendAxios(handleGoSaleSoon, handleGoHomepage, handleGoSaleStarts, handleGoSaleFinished);
    console.log("start connect", Socket);
    if (!Socket || !Socket.connected)
      Socket = io('lvlcs.dev-team.com', {
        transports: ['websocket'],
      });
    console.log(Socket, "end connect");

    dispatch(setConfigAsync());
    fetchStockStats();
    fetchSaleType();

    Socket.on("stats", (stats) => {
      console.log(stats);
      processNewStats(stats);
    });

    const intervalId = setInterval(() => {
      fetchSaleType();
    }, 15000);

    return () => {
      Socket.off("stats");
      clearInterval(intervalId);
      Socket.disconnect()
    };
  }, []);

  const handlePrev = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  }

  const handleNext = () => {
    if (currentStep < pages.length) {
      setCurrentStep(currentStep + 1);
    }
  }

  const handleGoHomepage = () => {
    localStorage.removeItem(UserDeadline);
    localStorage.removeItem(SavedStateKey);
    dispatch(resetSession());
    dispatch(resetOrderInfo());
    setCurrentStep(startStep);
  }

  const handleGoQuiz = () => {
    setCurrentStep(2);
  }

  const handleGoQueue = () => {
    setCurrentStep(100);
  }

  const handleGoShippingInfo = () => {
    setCurrentStep(3);
  }

  const handleGoSaleSoon = () => {
    setCurrentStep(500);
  }

  const handleGoSaleStarts = () => {
    setCurrentStep(501);
  }

  const handleGoSaleFinished = () => {
    setCurrentStep(502);
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    });

    if (!config.blockfrostKey) return;

    UpdateStatePageNumber({number: currentStep});
    
    fetchSaleType();

  }, [currentStep])

  useEffect(() => {
    async function initFromLocalStorage() {
      if (!config.blockfrostKey) return;

      const storedData = localStorage.getItem(SavedStateKey);
      const combinedData = storedData ? JSON.parse(storedData) : {};

      if (combinedData) {
        combinedData.shippingInfo ? dispatch(setOrderInfo(combinedData.shippingInfo)) : dispatch(resetOrderInfo());
        dispatch(setOrderItem(combinedData.orderItemAmount ? combinedData.orderItemAmount : 1));
        dispatch(setWalletAsync(combinedData.wallet ? combinedData.wallet : null, config));

        const session = localStorage.getItem(SessionId);
        if (session)
          dispatch(setSession(session));

        const deadline = localStorage.getItem(UserDeadline);
        const actualPageNumber = combinedData.pageNumber; 
        if (actualPageNumber && actualPageNumber <= 4 && actualPageNumber >= 3) {
        
          if (deadline && deadline < new Date().getTime())
            handleGoHomepage();
          else {
            const openTxid = localStorage.getItem(OpenTxid);
            Socket.emit("setOpenOrderInfo", { openTxid: openTxid });
            setCurrentStep(combinedData.pageNumber ? combinedData.pageNumber : startStep);
          }
        } else {
          setCurrentStep(combinedData.pageNumber ? combinedData.pageNumber : startStep);
        }
      }
      else {
        setCurrentStep(startStep);
        dispatch(resetSession());
      }
    }
    
    initFromLocalStorage();
    
  }, [config.blockfrostKey])

  const selectedPage = pages.find(page => page.order === currentStep);
  if (selectedPage) {
    return selectedPage.stepComponent({
      handleNext,
      handlePrev,
      handleGoHomepage,
      handleGoQuiz,
      handleGoQueue,
      handleGoShippingInfo,
      fetchStockStats,
      startRetryingCreateContract
    });
  } else {
    return <div>Error: Page not found</div>;
  }
};
  
export default RouterPage;